import { useMutation } from 'react-query';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';
import type { SendReadMessageBody } from 'api/messageCommunication/types';

/**
 * Custom hook for sending a read message and handling the response using React Query.
 */
function useSendReadMessage() {
  const { showApiError } = useGlobalContext();
  const { messageCommunication: messageCommunicationApi } = useApiContext();

  const { mutate, isLoading } = useMutation(
    (body: SendReadMessageBody) =>
      messageCommunicationApi.notifications.sendReadMessage(body),
    {
      onError: (error) => {
        showApiError(error, 'Error al marcar como leído');
      }
    }
  );

  return {
    sendReadMessage: mutate,
    isSendReadMessageLoading: isLoading
  };
}

export default useSendReadMessage;
